import { Location as RouterLocation, useLocation } from 'react-router-dom';

type Location<T> = RouterLocation & { state: T };

const useTypedLocation = <T>(): Location<T> => useLocation() as Location<T>;

export default useTypedLocation;
